import React from 'react';
import { Plus } from 'lucide-react';
import sersImage from '../../assets/images/sers.png';
import sers2Image from '../../assets/images/sers_2.png';
import sers3Image from '../../assets/images/sers3.png';
import sers4Image from '../../assets/images/sers4.png';
import sers5Image from '../../assets/images/sers5.png';
import sers6Image from '../../assets/images/sers6.png';
import sers7Image from '../../assets/images/sers7.png';
import sers8Image from '../../assets/images/sers8.png';
import imgVemahiya from '../../assets/images/img_vemahiya.png';
import imgParchaiyan from '../../assets/images/img_parchaiyan.png';
import imgMereMurshid from '../../assets/images/img_meremurshid.png';
import imgOjhal from '../../assets/images/img_ojhal.png';
import imgRose from '../../assets/images/img_rose.png';
import imgSimit from '../../assets/images/img_simit.png';
import imgShankara from '../../assets/images/img_shankara.png';
import imgMajbooriyan from '../../assets/images/img_majbooriyan.png';
import imgSimpleWeb from '../../assets/images/img_simple_web.png';
import imgSimpleMob from '../../assets/images/img_simple_mob.png';

import personGreenImg from '../../assets/images/person_green.png';
import personPinkImg from '../../assets/images/person_pink.png';
import personRedImg from '../../assets/images/person_red.png';
import LiteYouTube from './LiteYouTube';
import starIconGreen from '../../assets/images/starIcon_green.png';
import starIconRed from '../../assets/images/starIcon_red.png';
import starIconPink from '../../assets/images/starIcon_pink.png';
import starIconOrange from '../../assets/images/starIcon_orange.png';
import Youtubeplayer from '../../assets/images/Youtubeplayer.png';
import { Player } from '@lottiefiles/react-lottie-player';




const ServicesSection = () => {
    const services = [
        {
            id: 1,
            title: "GROW ON SPOTIFY WITH LISTENER BASED PLAYLISTS",

            subtitle: (
                <>
                    We pitch your track to playlists curated by real users. No<br /> bots, no fake plays, just organic discovery.
                </>
            ),
            image: null, // Placeholder for Spotify cassette image
            features: [
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Real Listener Discovery",
                    description: "Playlists with engaged, daily listeners."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Organic Streaming Curve",
                    description: "Improves chances of algorithmic boosts."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Performance Monitoring",
                    description: "Weekly updates on playlist placements and growth."
                }
            ],
            backgroundColor: "bg-black",
            accentColor: "text-green-400"
        },
        {
            id: 2,
            title: "YOUTUBE ADS THAT FIND THE RIGHT AUDIENCE",
            subtitle: "Targeted campaigns that place your music video in front of real listeners and convert views into fans.",
            image: null, // Placeholder for YouTube video player
            videoTitle: "YouTube Ads That Find the Right Audience",
            features: [
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Smart Targeting",
                    description: "We show your song to users based on viewing behavior, locations, and artist interests."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Engagement Focused",
                    description: "Each campaign is optimized to hold attention and drive meaningful interaction."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Transparent Reporting",
                    description: "You'll receive detailed insights including views, demographics, watch time, and performance metrics."
                }
            ],
            backgroundColor: "bg-black",
            accentColor: "text-red-500"
        },
        {
            id: 3,
            title: "LET YOUR SONG TRAVEL ON INSTAGRAM",
            subtitle: (
                <>
                    We integrate your music into content that gets shared,<br /> saved, and discovered.
                </>
            ),
            image: null, // Placeholder for Instagram grid images
            features: [
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Pages That Create Buzz",
                    description: "Fan pages, lyrical accounts, edits, meme creators."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Content That Resonates",
                    description: "Content that sparks shares and feels natural."
                },
                {
                    icon: <Plus className="w-4 h-4" />,
                    title: "Reel Optimization",
                    description: "Cuts and formats designed for engagement."
                }
            ],
            backgroundColor: "bg-black",
            accentColor: "text-pink-500"
        }
    ];

    return (
        <section id="spotify-section" className="relative z-10 py-20 bg-black">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="space-y-32">
                    {services.map((service, index) => (
                        <div key={service.id} className={`${service.backgroundColor} text-white`}>

                            {/* Centered Section Header */}
                            <div className="text-center mb-16">
                                <h2 className="text-2xl md:text-4xl font-normal mb-6">
                                    {service.id === 1 && (
                                        <>GROW ON <span className={service.accentColor}>SPOTIFY</span> WITH LISTENER BASED PLAYLISTS</>
                                    )}
                                    {service.id === 2 && (
                                        <><span className={service.accentColor}>YOUTUBE</span> ADS THAT FIND THE<br />RIGHT AUDIENCE</>
                                    )}
                                    {service.id === 3 && (
                                        <>LET YOUR SONG TRAVEL ON <span className={service.accentColor}>INSTAGRAM</span></>
                                    )}
                                </h2>
                                <p className=" hidden md:block text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
                                    {service.subtitle}
                                </p>
                            </div>

                            {/* Service 1 - Spotify (Layout: Features Left, Image Right) */}
                            {service.id === 1 && (
                                <div className="grid lg:grid-cols-2 gap-12 items-center ">
                                    {/* Left Column - Features */}
                                    <div className="space-y-8 order-2 lg:order-1">
                                        {/* Features List */}
                                        <div className="space-y-8">
                                            {service.features.map((feature, idx) => (
                                                <div key={idx} className="flex items-start space-x-4 md:block md:space-x-0">
                                                    <div className={`flex-shrink-0 ${service.accentColor} mt-1 md:mb-3`}>
                                                        {/* <Sparkle className="w-6 h-6" fill="currentColor" /> */}
                                                        <img src={starIconGreen} className="w-6 h-6" />
                                                    </div>
                                                    <div>
                                                        <h4 className="text-xl font-normal text-white mb-3">
                                                            {feature.title}
                                                        </h4>
                                                        <p className="text-gray-400 text-base leading-relaxed">
                                                            {feature.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Right Column - Image Placeholder */}
                                    <div className="flex justify-center order-1 lg:order-2">
                                        <div className="w-full h-[484px] rounded-lg overflow-hidden">
                                                                                        <video
                                                                                            controls={false}
                                                                                            className="w-full h-full object-cover rounded-lg no-overlay"
                                                src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757181724/Scene-4_1_hss16p.mp4'}
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                                preload="metadata"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Service 2 - YouTube (Layout: Video Left, Features Right) */}
                            {service.id === 2 && (
                                <div className="grid lg:grid-cols-2 gap-12 items-center">
                                    <div className="space-y-6">
                                        <div className="bg-black rounded-lg overflow-hidden">
                                            <div className="w-full h-full rounded-lg overflow-hidden">
                                                <Player
                                                    autoplay
                                                    loop
                                                    src={'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1757239934/Scene-7_tpcmme.json'}
                                                    className="w-full md:w-[640px] md:h-[443px] object-cover rounded-lg"
                                                />
                                            </div>
                                            {/* <LiteYouTube videoId="rBPOtsl1pkE" title="Chalte Hai Wahan – Sparsh Jain" /> */}

                                            {/* <div className="aspect-video bg-black flex items-center justify-center">
                                                <div className="text-center text-white">
                                                    <div className="text-6xl mb-4">▶️</div>
                                                    <p className="font-normal">YouTube Video Player</p>
                                                    <p className="text-sm text-gray-400">Add your video here</p>
                                                </div>
                                            </div>

                                            <div className="bg-black p-4 flex items-center space-x-4">
                                                <div className="text-white font-normal">Artistto</div>
                                                <div className="flex-1 h-1 bg-gray-600 rounded">
                                                    <div className="w-1/3 h-full bg-red-500 rounded"></div>
                                                </div>
                                                <div className="text-gray-400 text-sm">3:45 / 5:30</div>
                                            </div> */}
                                        </div>
                                    </div>

                                    <div className="space-y-8">
                                        <div className="space-y-8">
                                            {service.features.map((feature, idx) => (
                                                <div key={idx} className="flex items-start space-x-4 md:block md:space-x-0">
                                                    <div className={`flex-shrink-0 ${service.accentColor} mt-1 md:mb-3`}>
                                                        {/* <Sparkle className="w-6 h-6" fill="currentColor" /> */}
                                                        <img src={starIconRed} className="w-6 h-6" />

                                                    </div>
                                                    <div>
                                                        <h4 className="text-xl font-normal text-white mb-3">
                                                            {feature.title}
                                                        </h4>
                                                        <p className="text-gray-400 text-base leading-relaxed">
                                                            {feature.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Service 3 - Instagram (Layout: Features Left, Images Right) */}
                            {service.id === 3 && (
                                <div className="grid lg:grid-cols-2 gap-12 items-center">
                                    {/* Left Column - Features */}
                                    <div className="space-y-8 order-2 lg:order-1">
                                        {/* Features List */}
                                        <div className="space-y-8">
                                            {service.features.map((feature, idx) => (
                                                <div key={idx} className="flex items-start space-x-4 md:block md:space-x-0">
                                                    <div className={`flex-shrink-0 ${service.accentColor} mt-1 md:mb-3`}>
                                                        {/* <Sparkle className="w-6 h-6" fill="currentColor" /> */}
                                                        <img src={starIconPink} className="w-6 h-6" />

                                                    </div>
                                                    <div>
                                                        <h4 className="text-xl font-normal text-white mb-3">
                                                            {feature.title}
                                                        </h4>
                                                        <p className="text-gray-400 text-base leading-relaxed">
                                                            {feature.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Right Column - Instagram GIF */}
                                    <div className="flex justify-center order-1 lg:order-2">
                                        <div className="w-full h-[484px] rounded-lg overflow-hidden">
                                                                                        <video
                                                                                            controls={false}
                                                src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757183782/Scene-2_xwy2ee.mp4'}
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                                preload="metadata"
                                                className="w-full h-full object-cover rounded-lg no-overlay"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>

            {/* Campaign Highlights - Full Width Section */}
            <div className="w-full mt-[128px] ">
                                <video
                                    controls={false}
                                    className="w-full h-auto md:h-[600px] object-cover no-overlay"
                    src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757184341/947ab9ea8298f4b4ca2c769db57ba4f877d1b559_mwyxov.mp4'}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                />
            </div>

            {/* Proven Results Section */}
            <div className="bg-black  mt-[128px]">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Header */}
                    <div className="text-center mb-16 hidden md:block">
                        <h2 className="text-2xl md:text-4xl lg:text-5xl font-normal text-white mb-6">
                            PROVEN RESULTS WITH REAL STATS
                        </h2>
                        <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
                            A few of our most impactful campaigns and what they achieved.
                        </p>
                    </div>


                </div>
            </div>

            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgMajbooriyan} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Majbooriyan</h3>
                        <p className="text-gray-400 text-sm">Amitabh Narayan</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">400K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                {/* <Sparkle className="w-4 h-4 mr-2" fill="currentColor" /> */}
                                <img src={personGreenImg} className="w-4 h-4 mr-2" />
                                Streams On Spotify
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personPinkImg} className="w-4 h-4 mr-2" />

                                Reach On Instagram
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">700K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personRedImg} className="w-4 h-4 mr-2" />

                                Views on YouTube
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgMajbooriyan} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Majbooriyan</h3>
                            <p className="text-gray-400 text-base">Amitabh Narayan</p>
                        </div>
                    </div>

                    {/* Right Side - Stats */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sersImage}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </div>

            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgOjhal} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Ojhal</h3>
                        <p className="text-gray-400 text-sm">SHUNYA</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">1M+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personGreenImg} className="w-4 h-4 mr-2" />

                                Streams On Spotify
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-purple-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Reach On Instagram
                            </div>
                        </div> */}

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">200K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personRedImg} className="w-4 h-4 mr-2" />

                                Views on YouTube
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers2Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>


                    {/* Right Side - Stats */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgOjhal} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Ojhal</h3>
                            <p className="text-gray-400 text-base">SHUNYA</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgRose} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Rose</h3>
                        <p className="text-gray-400 text-sm">Zenarita</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">100K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personGreenImg} className="w-4 h-4 mr-2" />

                                Streams On Spotify
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-purple-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Reach On Instagram
                            </div>
                        </div> */}

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">300K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personRedImg} className="w-4 h-4 mr-2" />

                                Views on YouTube
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgRose} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Rose</h3>
                            <p className="text-gray-400 text-base">Zenarita</p>
                        </div>
                    </div>

                    {/* Right Side - Stats */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers3Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgSimit} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Simti</h3>
                        <p className="text-gray-400 text-sm">Anumita Nandesan</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">200K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personGreenImg} className="w-4 h-4 mr-2" />

                                Streams On Spotify
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-purple-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Reach On Instagram
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">700K+</div>
                            <div className="text-red-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Views on YouTube
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers4Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>


                    {/* Right Side - Stats */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgSimit} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Simti</h3>
                            <p className="text-gray-400 text-base">Anumita Nandesan</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgParchaiyan} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Parchaiyaan</h3>
                        <p className="text-gray-400 text-sm">Qaran & Vilen</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">500K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personGreenImg} className="w-4 h-4 mr-2" />

                                Streams On Spotify
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-purple-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Reach On Instagram
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">700K+</div>
                            <div className="text-red-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Views on YouTube
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgParchaiyan} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Parchaiyaan</h3>
                            <p className="text-gray-400 text-base">Qaran & Vilen</p>
                        </div>
                    </div>

                    {/* Right Side - Stats */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers5Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgMereMurshid} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Mere murshid mere yara</h3>
                        <p className="text-gray-400 text-sm">Vishal Mishra</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">TOP 50</div>
                            <div className=" font-thin text-white mb-2">TRENDING</div>
                            <div className="text-3xl font-normal text-white mb-2">160K+</div>
                            {/* <div className="text-green-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Streams On Spotify
                            </div> */}
                        </div>

                        <div className="text-center">
                            {/* <div className="text-3xl font-normal text-white mb-2">15M+</div> */}
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personPinkImg} className="w-4 h-4 mr-2" />

                                Reach On Instagram
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">700K+</div>
                            <div className="text-red-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Views on YouTube
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers6Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>


                    {/* Right Side - Stats */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgMereMurshid} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Mere murshid mere yara</h3>
                            <p className="text-gray-400 text-base">Vishal Mishra</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgVemahiya} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Ve mahiya</h3>
                        <p className="text-gray-400 text-sm">Bpraak </p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">400K+</div>
                            <div className="text-green-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Streams On Spotify
                            </div>
                        </div> */}

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">100K+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personPinkImg} className="w-4 h-4 mr-2" />

                                Reach On Instagram
                            </div>
                        </div>

                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">700K+</div>
                            <div className="text-red-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Views on YouTube
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgVemahiya} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Ve mahiya</h3>
                            <p className="text-gray-400 text-base">Bpraak </p>
                        </div>
                    </div>
                    {/* Right Side - Stats */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers7Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>

                </div>
            </div>


            {/* Mobile Layout */}
            <div className="block md:hidden">
                <div className=" p-6">
                    {/* Album Cover */}
                    <div className="flex justify-center mb-6">
                        <div className="w-[258px] h-[258px]   flex items-center justify-center relative overflow-hidden">
                            <img src={imgShankara} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>
                    </div>

                    {/* Artist Info */}
                    <div className="text-center mb-6">
                        <h3 className="text-xl font-normal text-white">Shankara Trance</h3>
                        <p className="text-gray-400 text-sm">Anshuman Sriwas</p>
                    </div>

                    {/* Stats */}
                    <div className="space-y-4">
                        {/* <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">400K+</div>
                            <div className="text-green-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Streams On Spotify
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">15M+</div>
                            <div className="text-purple-400 text-sm flex items-center justify-center">
                                <Sparkle className="w-4 h-4 mr-2" fill="currentColor" />
                                Reach On Instagram
                            </div>
                        </div> */}

                        <div className="text-center">
                            <div className="text-3xl font-normal text-white mb-2">1M+</div>
                            <div className="text-white text-sm flex items-center justify-center">
                                <img src={personRedImg} className="w-4 h-4 mr-2" />

                                Views on YouTube
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-center">
                <div className="flex items-center space-x-12 lg:space-x-20 max-w-6xl ">
                    {/* Left Side - Album Cover */}
                    <div className="flex-1 max-w-lg">
                        <img
                            src={sers8Image}
                            alt="Music Marketing Stats"
                            className="w-full h-auto"
                        />
                    </div>


                    {/* Right Side - Stats */}
                    <div className="flex-shrink-0">
                        <div className="w-72 h-72 lg:w-80 lg:h-80   flex items-center justify-center relative overflow-hidden">
                            <img src={imgShankara} alt="Majbooriyan" className="w-full h-full object-cover " />
                        </div>

                        {/* Artist Info Below Album */}
                        <div className="text-center mt-6">
                            <h3 className="text-xl lg:text-2xl font-normal text-white">Shankara Trance</h3>
                            <p className="text-gray-400 text-base">Anshuman Sriwas</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Getting Started Section */}
            <div className="bg-black pt-20">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Header */}
                    <div className="text-center mb-8 md:mb-16">
                        <h2 className="text-[24px] md:text-[36px] font-normal text-white md:mb-4">
                            GETTING STARTED IS SIMPLE
                        </h2>

                        {/* Main Quote Box */}

                        {/* Desktop Image */}
                        <img src={imgSimpleWeb} alt="Getting Started" className="hidden md:block w-full h-auto" />
                        {/* Mobile Image */}
                        <img src={imgSimpleMob} alt="Getting Started" className="block md:hidden w-full h-auto" />

                    </div>

                    {/* Steps */}
                    <div className="grid md:grid-cols-3 gap-[16px] md:gap-[28px] mb-16">
                        {/* Step 1 */}
                        <div className="text-left">
                            <div className="flex flex-row md:flex-col items-left mb-4">
                                <div className="flex items-center mr-4 md:mr-0 mb-0 md:mb-2">
                                    <img src={starIconOrange} className="w-6 h-6 mr-2" />
                                    <span className="text-[48px] text-4xl font-extrabold text-white">1</span>
                                </div>
                                <h4 className="text-[24px] font-light text-white md:w-[268px] w-[80%] ml-[14px]">
                                    Share your song and tell us your goal
                                </h4>
                            </div>
                        </div>

                        {/* Step 2 */}
                        <div className="text-left">
                            <div className="flex flex-row md:flex-col items-left mb-4">
                                <div className="flex items-center mr-4 md:mr-0 mb-0 md:mb-2">
                                    <img src={starIconOrange} className="w-6 h-6 mr-2" />
                                    <span className="text-[48px] text-4xl font-extrabold text-white">2</span>
                                </div>
                                <h4 className="text-[24px] font-light text-white md:w-[268px] w-[90%] ml-[14px]">
                                    We design a tailored campaign
                                </h4>
                            </div>
                        </div>

                        {/* Step 3 */}
                        <div className="text-left">
                            <div className="flex flex-row md:flex-col items-left mb-4">
                                <div className="flex items-center mr-4 md:mr-0 mb-0 md:mb-2">
                                    <img src={starIconOrange} className="w-6 h-6 mr-2" />
                                    <span className="text-[48px] text-4xl font-extrabold text-white">3</span>
                                </div>
                                <h4 className="text-[24px] font-light text-white md:w-[250px] w-[90%] ml-[14px]">
                                    You approve and we launch
                                </h4>
                            </div>
                        </div>
                    </div>



                    {/* Mobile Alternative CTA - Different Design */}
                    <div className="h-[400px] mt-16 bg-black-900 rounded-3xl p-8 text-center border border-white/20 flex items-center justify-center flex-col ">
                        <h3 className="text-[24px] md:text-[64px] font-semibold text-white mb-4 md:mb-0">
                            Let’s Launch Your Campaign
                        </h3>
                        <p className="text-white mb-4 text-[14px] md:text-[20px]">
                            Built for independent artists. Backed by real results.
                        </p>
                        <button className="bg-orange-500 hover:bg-orange-600 text-white font-normal py-4 px-[28px] rounded-xl text-[16px] transition-colors duration-300 max-w-[300px] md:w-auto" onClick={() => window.location.href = '/contact'}>
                            Start Your Campaign
                        </button>
                    </div>
                </div>
            </div>

        </section >
    );
};

export default ServicesSection;
